var _path, _path2, _path3, _path4, _path5, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVendorIconPmui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3226 4.22111C15.3226 4.96345 14.8866 5.7443 13.9602 6.38232C13.0381 7.01737 11.7095 7.44223 10.1936 7.44223C8.67766 7.44223 7.34901 7.01737 6.42692 6.38232C5.50054 5.7443 5.06458 4.96345 5.06458 4.22111C5.06458 3.47878 5.50054 2.69792 6.42692 2.05991C7.34901 1.42486 8.67766 1 10.1936 1C11.7095 1 13.0381 1.42486 13.9602 2.05991C14.8866 2.69792 15.3226 3.47878 15.3226 4.22111Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18C7.47445 17.7391 7.84214 17.2143 7.84214 17.2143L14.0222 10.5942C14.4129 10.1921 15.1927 10.096 15.764 10.3795C16.3353 10.663 16.4816 11.2187 16.0909 11.6208L9.28357 18.7049C8.89283 19.107 8.57126 18.2835 8 18Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9016 11.2035C11.3304 10.92 11.184 10.3643 11.5748 9.9622L12.0464 9.47686C12.4372 9.07479 13.217 8.97867 13.7883 9.26218L17.9257 11.3155C18.497 11.599 18.6433 12.1547 18.2526 12.5568L17.7809 13.0421C17.3902 13.4442 16.6103 13.5403 16.0391 13.2568L11.9016 11.2035Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.6181C1.6129 22.794 19.387 22.794 19.387 15.6181",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78327 13.5449C5.84249 14.6152 7.54784 14.6451 8.59227 13.6116C9.63671 12.578 9.62473 10.8725 8.56551 9.80209C7.75605 8.9841 6.56926 8.77377 5.58845 9.18132C5.63854 9.19538 5.68389 9.22019 5.72297 9.25724L7.48801 11.0409C7.88547 11.4426 7.88208 12.0904 7.48042 12.4878C7.07876 12.8853 6.43094 12.8819 6.03348 12.4803L4.26844 10.6966C4.23065 10.6612 4.20434 10.6201 4.1882 10.5746C3.77774 11.5486 3.97744 12.7305 4.78327 13.5449Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.36768,
    y: 12.0997,
    width: 7.97834,
    height: 1.80754,
    rx: 0.903771,
    transform: "rotate(45.3005 8.36768 12.0997)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorIconPmui);
export default __webpack_public_path__ + "static/media/vendor-icon-pmui.c632581f34ce72d0399d8c727ab4cca3.svg";
export { ForwardRef as ReactComponent };